/*
 * @Date: 2023-03-10 13:55:28
 * @LastEditors: Leo
 * @LastEditTime: 2023-03-10 13:55:28
 * @FilePath: \3.0-manger\src\js\components\quantity-input.js
 */
import "./index.less"
export default class QuantityInput extends HTMLElement {
    constructor() {
        super()
        this.input = this.querySelector('input')
        this.changeEvent = new Event('change', { bubbles: true })
    }

    connectedCallback() {
        // 初始化事件监听
        this.input.addEventListener('input', this.handleInputChange.bind(this))
        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        )

        // 初始化按钮状态
        setTimeout(() => this.updateButtonStatus(), 300)
    }

    disconnectedCallback() {
        // 清理事件监听
        this.input.removeEventListener('input', this.handleInputChange)
        this.querySelectorAll('button').forEach(
            (button) => button.removeEventListener('click', this.onButtonClick)
        )
        // 初始化按钮状态
        setTimeout(() => this.updateButtonStatus(), 300)
    }

    handleInputChange(e) {
        if (!e.isTrusted) return; // 避免循环触发
        this.validateInput(e.target)
        this.updateButtonStatus()
    }

    onButtonClick(event) {
        event.preventDefault()
        const previousValue = Number(this.input.value)

        if (isNaN(previousValue)) {
            console.warn('Invalid input value')
            return
        }

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
        
        if (previousValue !== Number(this.input.value)) {
            this.input.dispatchEvent(this.changeEvent)
            this.updateButtonStatus()
        }
        this.validateInput(this.input)
    }
    /**
     * 校验输入值是否在范围内
     * @param {HTMLInputElement} input - 输入框元素
     */
    validateInput(input) {
        if(document.querySelector(".add_cart_error_wrapper")) {
            document.querySelector(".add_cart_error_wrapper").textContent = ''
        }
        const value = Number(input.value)
        if (isNaN(value)) {
            console.warn('Invalid input value')
            return
        }

        if (input.min && value < Number(input.min)) {
            input.value = input.min
        }
        if (input.max && value > (Number(input.max) || 1000000)) {
            input.value = input.max || 1000000
            if(document.querySelector(".add_cart_error_wrapper")) {
                document.querySelector(".add_cart_error_wrapper").textContent = pageInfo.strings.product.max_inventory_quantity_error || ''
            }
        }
    }

    /**
     * 更新加减按钮的禁用状态
     */
    updateButtonStatus() {
        const minusButton = this.querySelector('button[name="minus"]')
        const plusButton = this.querySelector('button[name="plus"]')
        const currentValue = Number(this.input.value)
        const minValue = Number(this.input.getAttribute('min'))
        const maxValue = this.input.hasAttribute('max') ? Number(this.input.getAttribute('max')) : 1000000

        minusButton.toggleAttribute('disabled', currentValue <= minValue)
        plusButton.toggleAttribute('disabled', currentValue >= maxValue)
    }
}

